import React from 'react';
import {Switch, Route, Link} from 'react-router-dom';
import {Toolbar, TabsContainer, Tabs, Tab} from 'react-md';

import TestRunList from './TestRun/List';
import RunConfigurationList from './RunConfiguration/List';
//import './Index.css';


const toolbar = <Toolbar title="Project X"/>;

class Index extends React.Component {

    constructor(props) {
            super(props);
            this.state = {
              projectId: props.match.params.projectId,
              activeTab: 'testRunsTab'
            };

//this.showTab = this.showTab.bind(this);
        }



    showTab(activeTab) {
    this.setState({ activeTab: activeTab });
        }

render(){
var divStyle ={
cursor:'pointer',
color:'blue',
textDecoration:'underline'
};


var contentDivStyle ={
//marginTop: 150
};


var content;
 if(this.state.activeTab === 'testRunsTab'){
    content = <TestRunList projectId={this.state.projectId}/>;
 }else  if(this.state.activeTab === 'runConfigurationsTab'){
           content = <RunConfigurationList projectId={this.state.projectId}/>;
        }



   return (
    <div>
    <div>

            <ul id="subMenu">
                <li id="subMenuItem"><a style={divStyle} onClick={() => this.showTab('testRunsTab')}>Test Runs</a></li>
                <li id="subMenuItem"><a style={divStyle} nohref onClick={() => this.showTab('runConfigurationsTab')}>Run Configurations</a></li>

              </ul>
              </div>
              <div style={contentDivStyle}>

              {content}
              </div>

    </div>
   )
}

}

export default Index;



// WEBPACK FOOTER //
// ./src/containers/Project/Detail/Index.js